<template>
	<div class="admin-topbar">
		<BackLink classPrefix="admin-topbar" />
		<div class="admin-topbar__logo"></div>

		<router-link :to="{name: 'admin-pricelist'}" v-slot="{href, navigate, isExactActive}">
			<a
				:class="['admin-topbar__link', {'admin-topbar__link--active': isExactActive}]"
				:href="href"
				@click="navigate"
				>Aktualizacja cennika
			</a>
		</router-link>

		<router-link :to="{name: 'admin-configurations'}" v-slot="{href, navigate, isExactActive}">
			<a
				:class="['admin-topbar__link', {'admin-topbar__link--active': isExactActive}]"
				:href="href"
				@click="navigate"
				>Konfiguracje</a
			>
		</router-link>

		<router-link :to="{name: 'admin'}" v-slot="{href, navigate, isExactActive}">
			<a
				:class="['admin-topbar__link', {'admin-topbar__link--active': isExactActive}]"
				:href="href"
				@click="navigate"
				>Partnerzy</a
			>
		</router-link>

		<button
			@click.prevent="logout"
			role="button"
			class="button admin-topbar__logout button--outlined"
		>
			Wyloguj
		</button>
	</div>
</template>

<script>
import {api} from '@/core/services/api';
import BackLink from '../BackLink';

export default {
	name: 'AdminTopbar',
	components: {BackLink},
	methods: {
		async logout() {
			// It's a hack as basic auth doesn't support logout feature
			// Doesn't fully work on FF and presumably some other browsers
			// But should do for know
			try {
				await api.get('/logout', {
					auth: {
						username: 'janedoe',
						password: 's00pers3cret',
					},
				});
			} catch (e) {
			} finally {
				this.$router.replace('/');
			}
		},
	},
};
</script>
